export default __webpack_public_path__ + "static/media/sc4.37113c31.png";